import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { fetchAuthSession } from "aws-amplify/auth";

export const baseSecondGuaranteApi = createApi({
  reducerPath: "baseSecondGuaranteeApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_URL_API_SECOND_GUARANTEE,

    prepareHeaders: async (headers: Headers, api) => {
      if (api.endpoint === "uploadFileSecondGuarantee") {
        return headers;
      }

      const session = await fetchAuthSession();
      const token = session.tokens?.accessToken?.toString();

      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }

      return headers;
    },
  }),
  keepUnusedDataFor: 30,
  endpoints: () => ({}),
});
